export default __webpack_public_path__ + "static/media/img1.308524c8.png";